import React from 'react';
import Search from './Search';
import TemplateInfoTab from './templateInfo/TemplateInfoTab';
import AuditInfoTab from './auditInfo/AuditInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';
import * as Help from 'modules/app/Help';

class EmailTemplateSetup extends React.Component {
    
    render() {

		let opts = {
			title: "Email Templates Setup",
			description: "Review and modify the templates used in automatic e-mail notifications",
			addPrivilege: false, // Template creation is no allowed for now
			addNewTitle: "Create Template",
			enableExport: false,
			helpKey: Help.emailTemplateSetupHelpKey,
			recentType: "emailTemplate",
			sortField: "description",
			list: {
                url: API.Emailing.url('/EmailTemplateSetup/Search'),
				rowKey: "emailTemplateCode",
				columns: [					
					{ key: 'description', name: 'Title', width: 300, sortable: true, cellClass: "text-left" },
					{ key: 'emailCategory', name: 'Category', width: 150,sortable: true, cellClass: "text-left" },
					{ key: 'subject', name: 'Subject', sortable: true, cellClass: "text-left" },					
				]
			},
			tabs: [
				{ key: "templateInfo", title: "Template Info", comp: TemplateInfoTab, helpKey: Help.emailTemplateSetupInfoHelpKey },
				{ key: "auditInfo", title: "Audit Info", comp: AuditInfoTab } 
			]
		};

		opts = Object.assign(opts, this.props);

		return (
			<SetupPage {...opts}
				Search={Search} />
		);
	}
}

export default EmailTemplateSetup;


// WEBPACK FOOTER //
// ./src/areas/admin/emailingTemplateSetup/EmailTemplateSetup.js